import { createSelector } from '@reduxjs/toolkit';
import { RootState } from '@store/store';
import { Article } from '@api/types/Article';
import { LanguageEnum } from '@project-types/LanguageEnum';
import { generateGuid, invalidFormValue, isValidUrl } from '@components/utils';
import { selectLanguage } from '@store/global/selectors';



export const selectOriginalArticle = (state: RootState) => state.article.originalArticle;
export const selectGuid = (state: RootState) => state.article.guid;
export const selectCountry = (state: RootState) => state.article.country;
export const selectUrl = (state: RootState) => state.article.url;
export const selectName = (state: RootState) => state.article.name;
export const selectContent = (state: RootState) => state.article.content;



export const selectValidArticle = createSelector(
	[
		selectGuid,
		selectCountry,
		selectUrl,
		selectName,
		selectContent,
		selectLanguage,
	],(
		guid: string | null,
		country: LanguageEnum | null,
		url: string,
		name: string,
		content: string,
		appLanguage: LanguageEnum,
	) => {
		if (!isValidUrl(url)) return null;
		if (invalidFormValue(name)) return null;
		if (invalidFormValue(content)) return null;
		
		const newArticle: Article = {
			guid: guid ? guid : generateGuid(),
			country: country ? country : appLanguage,
			url: url,
			name: name,
			content: content
		}
		return newArticle;
	}
);